import { z } from 'zod';
import { ConnectedClientAccessSchema } from '../identity/connected-clients.schemas';

/**
 * Bus event emitted when a member changes a connected client's access. Ids and
 * permission lists only — no token, no client secret.
 */
export const ConnectedClientAccessUpdatedPayloadSchema = z.object({
  connectedClientId: z.uuid(),
  userId: z.uuid(),
  /** The seat the edit was made from. */
  workspaceId: z.uuid(),
  /** The editing member — the audit actor. */
  memberId: z.uuid(),
  previousAccess: ConnectedClientAccessSchema,
  access: ConnectedClientAccessSchema,
  /** Wire projections: `[]` when the matching access is ALL_TOOLS. */
  previousPermissions: z.array(z.string()),
  grantedPermissions: z.array(z.string()),
  occurredAt: z.iso.datetime(),
});

export type ConnectedClientAccessUpdatedPayload = z.infer<typeof ConnectedClientAccessUpdatedPayloadSchema>;
